import type { ReferenceListState, ReferenceListContextValues } from './ReferenceList.types';

export function useReferenceListContextValues_unstable(state: ReferenceListState): ReferenceListContextValues {
  const {
    areReferencesExpanded,
    maxVisibleReferences,
    overflowButtonTriggeredViaKeyboard,
    referenceListRef,
    shouldUseOverflow,
    totalReferencesCount,
  } = state;

  // This context is created with "@fluentui/react-context-selector", there is no sense to memoize it
  const referenceList = {
    areReferencesExpanded,
    maxVisibleReferences,
    overflowButtonTriggeredViaKeyboard,
    referenceListRef,
    shouldUseOverflow,
    totalReferencesCount,
  };

  return { referenceList };
}
